<template>
  <div>
    <div class="footer-top text-bg-secondary py-4">
      <div class="container d-flex flex-column flex-lg-row justify-content-start align-items-center fs-5 footer-icon-section">
        <div class="d-inline-flex flex-column flex-md-row align-items-center">
          <label for="newsletter-email" class="col-form-label fw-bold me-4 text-uppercase text-nowrap">{{
            $t("newsletter_subscriptions")
          }}</label>
          <div class="input-group">
            <input
              type="email"
              class="form-control form-control-lg"
              id="newsletter-email"
              :placeholder="$t('email_placeholder')"
              aria-label="E-mailadres"
              aria-describedby="newsletter-submit"
              v-model="email"
            >
            <button
              @click="subscribe(email)"
              class="btn btn-thirdary"
              type="button"
              id="newsletter-submit"
            >
              {{ $t("register") }}
            </button>
          </div>
        </div>
        <div class="social-follow">
          <ul class="list-inline mb-0 d-flex">
            <li class="list-inline-item fw-bold mt-2">Volg ons op:</li> 
            <li>
            <cmsBlockSimple
              v-if="typeof socialMedia == 'object'"
              :identifier="socialMedia.identifier"
            />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import User from "@storefront/core/modules/user/mixins";
import getImageUrl from "@/esf_antarctica_lederhosenland/helpers/getImageUrl";
import cmsBlockSimple from "@/esf_antarctica_lederhosenland/core/components/common/BlockSimple.vue";

export default {
   components: {
    cmsBlockSimple
  },
  mixins: [User],
  data() {
    return { email: "" };
  },
  methods: {
    imgUrl(filename) {
      return getImageUrl(filename);
    },
  },
  computed: {
    socialMedia() {
      return this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
        "social_plateform"
      );
    },
  },
};
</script>

<style></style>
